export { usePeriodsUIStore } from './periodsUIStore';
export { useDashboardUIStore } from './dashboardUIStore';
export { useCostCentersUIStore } from './costCentersUIStore';
export { useBalanceUIStore } from './balanceUIStore';
export { useClassifiedExpenseUIStore } from './classifiedExpenseUIStore';
export { useAnalyticsUIStore } from './analyticsUIStore';

import { usePeriodsUIStore } from './periodsUIStore';
import { useDashboardUIStore } from './dashboardUIStore';
import { useCostCentersUIStore } from './costCentersUIStore';
import { useBalanceUIStore } from './balanceUIStore';
import { useClassifiedExpenseUIStore } from './classifiedExpenseUIStore';
import { useAnalyticsUIStore } from './analyticsUIStore';

export function resetAllUIStores() {
  usePeriodsUIStore.getState().reset();
  useDashboardUIStore.getState().reset();
  useCostCentersUIStore.getState().reset();
  useBalanceUIStore.getState().reset();
  useClassifiedExpenseUIStore.getState().reset();
  useAnalyticsUIStore.getState().reset();
}
